import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { trashKeys, usersKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useRestoreUsers() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: number): Promise<void> => {
      await apiClient.url(`/users/restore/${userId}`).post().res();
    },
    onError: (error: Error) => {
      toast.add({
        description: error.message || "Failed to restore users",
        timeout: 3000,
        type: "error",
      });
    },
    onSuccess: () => {
      toast.add({
        description: "User restored successfully",
        timeout: 3000,
        type: "success",
      });
      queryClient.invalidateQueries({ queryKey: trashKeys.all });
      queryClient.invalidateQueries({ queryKey: usersKeys.all });
    },
  });
}
